import { useStaticQuery, graphql } from 'gatsby'

export const useFooterQuery = () => {
  const { wp, footerMenu1, footerMenu2 } = useStaticQuery(graphql`
    query FooterQuery {
      wp {
        acfOptionsCommonItems {
          commonItems {
            phoneNumber
            footer {
              footerLogo {
                localFile {
                  childImageSharp {
                    gatsbyImageData(formats: WEBP, sizes: "(min-width: 1024px) 19vw, 66vw")
                  }
                }
              }
              footerLogoAltText
              text
              locations {
                sectionLabel
                addressLabel
                address
                callLabel
              }
              hours {
                sectionLabel
                hours
              }
              socialMedia {
                socialMediaIcon {
                  localFile {
                    publicURL
                  }
                }
                socialMediaLink {
                  url
                }
              }
              copyright
              nexvelLogo {
                localFile {
                  publicURL
                }
              }
              nexvelLogoAltText
              nexvelLink {
                url
              }
            }
          }
        }
      }
      footerMenu1: wpMenu(locations: { eq: FOOTER_MENU1 }) {
        menuItems {
          nodes {
            menu {
              node {
                name
              }
            }
            label
            path
          }
        }
      }
      footerMenu2: wpMenu(locations: { eq: FOOTER_MENU2 }) {
        menuItems {
          nodes {
            menu {
              node {
                name
              }
            }
            label
            path
            target
          }
        }
      }
    }
  `)
  return { wp, footerMenu1, footerMenu2 }
}
